var map = {
	"./admin_settings.png": 1318,
	"./catalog.png": 1319,
	"./catalog_order.png": 1320,
	"./cms.png": 1321,
	"./component-fields/Asset.png": 1322,
	"./component-fields/Blocks.png": 1323,
	"./component-fields/Boolean.png": 1324,
	"./component-fields/Date-time.png": 1325,
	"./component-fields/LInk.png": 1326,
	"./component-fields/Markdown.png": 1327,
	"./component-fields/Multi asset.png": 1328,
	"./component-fields/Multi options.png": 1329,
	"./component-fields/Number.png": 1330,
	"./component-fields/Richtext.png": 1331,
	"./component-fields/Single options.png": 1332,
	"./component-fields/Table.png": 1333,
	"./component-fields/Text area.png": 1334,
	"./component-fields/Text.png": 1335,
	"./components.png": 1336,
	"./contents.png": 1337,
	"./custom_order.png": 1338,
	"./customer_credits.png": 1339,
	"./dashboard.png": 1340,
	"./dashboard_available_credit.png": 1341,
	"./dashboard_due_soon.png": 1342,
	"./dashboard_invoices.png": 1343,
	"./dashboard_market.png": 1344,
	"./dashboard_messages.png": 1345,
	"./dashboard_new_arrivals.png": 1232,
	"./dashboard_new_catalog_order.png": 1227,
	"./dashboard_new_custom_order.png": 1229,
	"./dashboard_new_estimate.png": 1228,
	"./dashboard_new_payment.png": 1231,
	"./dashboard_new_repair.png": 1230,
	"./dashboard_orders.png": 1346,
	"./dashboard_past_due.png": 1347,
	"./dashboard_quotes.png": 1348,
	"./dashboard_sales_orders.png": 1349,
	"./dashboard_total_payable.png": 1350,
	"./estimate.png": 1351,
	"./financials.png": 1352,
	"./home.png": 1353,
	"./invoices.png": 1354,
	"./media_library.png": 1355,
	"./move.png": 1356,
	"./order_creation.png": 1357,
	"./orders.png": 1358,
	"./payment-methods/amex.png": 1155,
	"./payment-methods/discover.png": 1154,
	"./payment-methods/mastercard.png": 1153,
	"./payment-methods/visa.png": 1152,
	"./payment.png": 1359,
	"./quotes.png": 1360,
	"./repair_order.png": 1361,
	"./sales_orders.png": 1362,
	"./status_tracking.png": 1363
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1174;